<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <kisiadresara
      v-model="adresDialogData"
      v-bind:value="vizeKisi"
    ></kisiadresara>
    <tanitimMail ref="tanitimdialog" :servisTipi="1"></tanitimMail>
    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title v-if="islemTipi != 'hredit'">
              {{ $t("Make-a-Reservation") }}
            </v-toolbar-title>
            <v-toolbar-title v-if="islemTipi == 'hredit'">
              Rezervasyon Güncelle</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
      <hotelloadingcomp
        ref="hotelloadingcomp"
        iconname="local_hotel"
        v-bind:mesaj="text1"
        v-model="loadingdialog"
      ></hotelloadingcomp>

      <v-form ref="formrezervasyon" v-model="validform" lazy-validation>
        <v-flex xs12 sm12 md12 pa-2>
          <v-layout row wrap>
            <v-flex xs12 sm9 md9>
              <v-layout row wrap>
                <v-flex pb-2 v-if="islemTipi == 'hryeni'" xs12 sm12 md12>
                  <v-card flat>
                    <v-card-title primary-title>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 pt-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t("Current-Details") }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>

                        <v-flex pl-4 xs12 sm12 md12>
                          <caricomp
                            v-bind:autofocuss="true"
                            :Coper="true"
                            v-bind:statecariyedek="statecari"
                            v-bind:zorunlumu="true"
                            v-model="carikod"
                          >
                          </caricomp>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                  </v-card>
                </v-flex>

                <v-flex pt-2 pb-2 v-if="islemTipi == 'hredit'" xs12 sm12 md12>
                  <v-card flat>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 pt-2 pl-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t("General-Information") }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 pt-2 pl-4 md12>
                          <v-layout row wrap>
                            <v-flex xs4 pl-2 sm4 md3>
                              <v-layout row wrap>
                                <v-flex xs12 pl-2 sm12 md12>
                                  <span class="grey--text title">
                                    {{ otelInfo.HotelName }}</span
                                  >-
                                  <span class="grey--text caption">
                                    {{ otelInfo.CityName }} |
                                    {{ otelInfo.CountryLongName }}</span
                                  >
                                </v-flex>

                                <v-flex xs12 pl-2 sm12 md12>
                                  <span class="grey--text caption">
                                    {{ otelInfo.RateName }}
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 pb-2 sm12 md2>
                              <v-layout row wrap>
                                <v-flex pt-2 pb-2 pr-4 xs12 sm12 md12>
                                  <v-layout justify-center>
                                    <span class="grey--text caption">
                                      {{ $t("Check-in-Date") }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 pb-1 sm12 md12>
                                  <v-layout justify-center>
                                    <span class="title red--text">{{
                                      reservation.StartDate | dateformat
                                    }}</span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 pb-2 sm12 md2>
                              <v-layout row wrap>
                                <v-flex pt-2 pb-2 pr-4 xs12 sm12 md12>
                                  <v-layout justify-center>
                                    <span class="grey--text caption">
                                      {{ $t("Check-out-Date") }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 pb-1 md12>
                                  <v-layout justify-center>
                                    <span class="title red--text">
                                      {{
                                        reservation.EndDate | dateformat
                                      }}</span
                                    >
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md4>
                              <v-layout align-center fill-height row wrap>
                                <v-flex xs3 sm3 md4>
                                  <v-layout row wrap align-center>
                                    <v-icon color="grey">person</v-icon>
                                    &nbsp;<span class="grey--text"
                                      >{{ this.reservation.AdultCount }}
                                      {{ $t("Adult") }}</span
                                    >
                                  </v-layout>
                                </v-flex>

                                <v-flex xs3 sm3 md4>
                                  <v-layout row wrap align-center>
                                    <v-icon color="grey">child_care</v-icon>
                                    &nbsp;<span class="grey--text"
                                      >{{ this.reservation.ChildCount }}
                                      {{ $t("Child") }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs3 sm3 md4>
                                  <v-layout row wrap align-center>
                                    <v-icon color="grey">brightness_3</v-icon>
                                    &nbsp;<span class="grey--text"
                                      >{{ gunfarki(
                                        otelInfo.CheckInTime,
                                      otelInfo.CheckOutTime
                                      ) }}  {{ $t("night") }}</span
                                    >
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 v-if="!alternatifarama" sm1 md1>
                              <v-layout align-center fill-height justify-end>
                                <v-btn
                                  color="green"
                                  flat
                                  @click.native="
                                    alternatifarama = !alternatifarama
                                  "
                                >
                                  <span class="title green--text"
                                    >{{ $t("Change") }}
                                  </span>
                                </v-btn>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 v-if="alternatifarama" sm1 md1>
                              <v-layout align-center fill-height justify-end>
                                <v-btn
                                  color="green"
                                  flat
                                  @click.native="
                                    alternatifarama = !alternatifarama
                                  "
                                >
                                  <span class="title green--text">{{
                                    $t("cancel_button")
                                  }}</span>
                                </v-btn>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-flex>

                <v-flex
                  pt-2
                  pb-2
                  v-if="islemTipi == 'hredit' && alternatifarama"
                  xs12
                  sm12
                  md12
                >
                  <v-card flat>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 pt-2 pl-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t("Availability-Status") }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 pt-2 pl-4 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm4 md2 pl-4>
                              <tarihcomp
                                :etiket="$t('Check-in-Date')"
                                :detaygizle="false"
                                v-model="alternatifInput.BaslangicTarih"
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                v-bind:defaultvalue="'ok'"
                              >
                              </tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm4 md2>
                              <tarihcomp
                                :etiket="$t('Finishing-Date')"
                                :detaygizle="false"
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                v-bind:defaultvalue="'ok'"
                                v-model="alternatifInput.BitisTarih"
                              >
                              </tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm4 md1>
                              <v-select
                                :label="$t('Markup-Type')"
                                v-model="alternatifInput.MarkupTip"
                                :items="markupitems"
                                item-text="text"
                                item-value="value"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm4 md1>
                              <parainput
                                v-if="alternatifInput.MarkupTip == 0"
                                v-model="alternatifInput.MarkupDeger"
                                :simge="getparabirimi()"
                                :etiket="$t('Markup-Amount')"
                                :autocomplete="'autocomplete'"
                              ></parainput>

                              <yuzdeinput
                                v-if="alternatifInput.MarkupTip == 1"
                                :etiket="$t('Markup-Percentage')"
                                v-model="alternatifInput.MarkupDeger"
                              >
                              </yuzdeinput>
                            </v-flex>

                            <v-flex xs12 sm2 md2>
                              <v-layout align-center fill-height justify-start>
                                <v-btn
                                  color="green"
                                  flat
                                  @click="musaitOdaGetir()"
                                >
                                  <v-icon color="green">search</v-icon> &nbsp;
                                  <span class="title green--text">
                                    {{ $t("Find-Room") }}
                                  </span>
                                </v-btn>
                              </v-layout>
                            </v-flex>

                            <!--
                                                        <v-flex xs12 pb-2 sm12 md2>
                                                            <v-layout row wrap>
                                                                <v-flex pt-2 pb-2 pr-4 xs12 sm12 md12>
                                                                    <v-layout justify-center>
                                                                        <span class="grey--text caption">
                                                                            Giriş Tarihi</span>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 pb-1 sm12 md12>
                                                                    <v-layout justify-center>
                                                                        <span
                                                                            class="title red--text">{{rezervasyon.BaslangicTarih | dateformat}}</span>
                                                                    </v-layout>
                                                                </v-flex>

                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 pb-2 sm12 md2>
                                                            <v-layout row wrap>

                                                                <v-flex pt-2 pb-2 pr-4 xs12 sm12 md12>
                                                                    <v-layout justify-center>
                                                                        <span class="grey--text caption">
                                                                            Çıkış Tarihi</span>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 pb-1 md12>
                                                                    <v-layout justify-center>
                                                                        <span class="title red--text">
                                                                            {{rezervasyon.BitisTarih | dateformat}}</span>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>-->

                            <!--
                                                        <v-flex xs12 sm12 md6>
                                                            <v-layout align-center fill-height row wrap>
                                                                <v-flex xs3 sm3 md4>
                                                                    <v-layout row wrap align-center>
                                                                        <v-icon color="grey">person</v-icon>
                                                                        &nbsp;<span
                                                                            class="grey--text">{{this.rezervasyon.YetiskinSayi}}
                                                                            Yetişkin</span>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs3 sm3 md4>
                                                                    <v-layout row wrap align-center>
                                                                        <v-icon color="grey">child_care</v-icon>
                                                                        &nbsp;<span
                                                                            class="grey--text">{{this.rezervasyon.CocukSayi}}
                                                                            Çocuk</span>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs3 sm3 md4>
                                                                    <v-layout row wrap align-center>

                                                                        <v-icon color="grey">brightness_3</v-icon>
                                                                        &nbsp;<span class="grey--text">{{gunfarki()}}
                                                                            gece</span>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex> -->
                          </v-layout>
                        </v-flex>

                        <v-flex xs9 pl-3 sm12 md12>
                          <v-layout row wrap>
                            <v-flex
                              pt-2
                              pb-2
                              v-if="
                                islemTipi == 'hredit' && alternatifkayitvarmi
                              "
                              xs12
                              sm12
                              md12
                            >
                              <v-card flat>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 pt-2 pl-4 md12>
                                      <v-layout row wrap>
                                        <v-layout row wrap>
                                          <v-flex xs12 pb-2 sm12 md2>
                                            <v-layout row wrap>
                                              <v-flex
                                                pt-2
                                                pb-2
                                                pr-4
                                                xs12
                                                sm12
                                                md12
                                              >
                                                <v-layout justify-center>
                                                  <span
                                                    class="grey--text caption"
                                                  >
                                                    {{
                                                      $t("Check-in-Date")
                                                    }}</span
                                                  >
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout justify-center>
                                                  <span
                                                    class="title grey--text"
                                                    >{{
                                                      alternatifitems.BaslangicTarih
                                                        | dateformat
                                                    }}</span
                                                  >
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 pb-2 sm12 md2>
                                            <v-layout row wrap>
                                              <v-flex
                                                pt-2
                                                pb-2
                                                pr-4
                                                xs12
                                                sm12
                                                md12
                                              >
                                                <v-layout justify-center>
                                                  <span
                                                    class="grey--text caption"
                                                  >
                                                    {{
                                                      $t("Check-out-Date")
                                                    }}</span
                                                  >
                                                </v-layout>
                                              </v-flex>
                                              <v-flex xs12 sm12 pb-1 md12>
                                                <v-layout justify-center>
                                                  <span
                                                    class="title grey--text"
                                                  >
                                                    {{
                                                      alternatifitems.BitisTarih
                                                        | dateformat
                                                    }}</span
                                                  >
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm12 md2>
                                            <v-layout
                                              align-center
                                              fill-height
                                              row
                                              wrap
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <v-layout row wrap>
                                                  <v-flex xs12 sm12 md12>
                                                    <v-layout
                                                      row
                                                      wrap
                                                      align-center
                                                    >
                                                      <v-icon color="grey">
                                                        person
                                                      </v-icon>
                                                      &nbsp;<span
                                                        class="grey--text"
                                                        >{{
                                                          this.reservation
                                                            .AdultCount
                                                        }}
                                                        {{ $t("Adult") }}</span
                                                      >
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm12 md12>
                                                    <v-layout
                                                      row
                                                      wrap
                                                      align-center
                                                    >
                                                      <v-icon color="grey">
                                                        child_care
                                                      </v-icon>
                                                      &nbsp;<span
                                                        class="grey--text"
                                                        >{{
                                                          this.reservation
                                                            .ChildCount
                                                        }}
                                                        {{ $t("Child") }}</span
                                                      >
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm12 md3>
                                            <v-layout
                                              align-center
                                              fill-height
                                              row
                                              wrap
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <v-layout row wrap>
                                                  <v-flex xs12 sm12 md12>
                                                    <v-layout
                                                      row
                                                      wrap
                                                      align-center
                                                    >
                                                      <span
                                                        class="grey--text mr-1"
                                                      >
                                                        <v-icon color="grey">
                                                          meeting_room
                                                        </v-icon>
                                                        {{
                                                          this.alternatifitems
                                                            .OdaTipi
                                                        }}
                                                      </span>
                                                    </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12 sm12 md12>
                                                    <v-layout
                                                      row
                                                      wrap
                                                      align-center
                                                    >
                                                      <v-icon color="grey">
                                                        brightness_3
                                                      </v-icon>
                                                      &nbsp;<span
                                                        class="grey--text"
                                                        >{{
                                                          gunfarkialternatif()
                                                        }}
                                                        {{ $t("night") }}</span
                                                      >
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-layout
                                              row
                                              wrap
                                              fill-height
                                              align-center
                                              justify-center
                                            >
                                              <span
                                                class="
                                                  font-weight-
                                                  red--text
                                                  mr-1
                                                "
                                              >
                                                <h2>
                                                  {{
                                                    alternatifitems.Tutar
                                                      | moneyformat
                                                  }}
                                                  {{ alternatifitems.Kur }}
                                                </h2>
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm1 md1>
                                            <v-layout
                                              align-center
                                              fill-height
                                              justify-end
                                            >
                                              <v-btn
                                                color="green"
                                                @click="
                                                  musaitOdaSec(alternatifitems)
                                                "
                                              >
                                                <span
                                                  class="title white--text"
                                                  >{{ $t("Select") }}</span
                                                >
                                              </v-btn>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>

                                        <v-flex
                                          xs12
                                          pt-3
                                          pb-4
                                          pl-2
                                          v-show="!alternatifkayitvarmi"
                                          sm12
                                          md12
                                        >
                                          <v-form
                                            ref="OtelFiyatGetir"
                                            v-model="validform"
                                            lazy-validation
                                          >
                                            <v-card flat>
                                              <v-layout row wrap=""> </v-layout>
                                            </v-card>
                                          </v-form>
                                        </v-flex>

                                        <v-flex pt-1 xs12 sm12 md12>
                                          <v-divider></v-divider>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-flex>

                <v-flex pb-2 xs12 sm12 md12>
                  <v-card flat>
                    <v-card-title primary-title>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 pt-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t("Contact-Information") }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>

                        <v-flex pl-4 xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field
                                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                :label="$t('Email_label')"
                                v-model="reservation.Mail"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 pl-2 sm6 md6>
                              <v-text-field
                                :label="$t('Mobilphonenumber_label')"
                                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                v-model="reservation.Phone"
                              >
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 pl-4 sm12 md12>
                          <v-textarea
                            v-model="reservation.Address"
                            :label="$t('Address_label')"
                          >
                          </v-textarea>
                        </v-flex>
                        <!-- <v-flex xs12 pl-4 sm12 md12>
                                            <v-checkbox label="Arkman bana bilgilendirme ve tanıtım amaçlı eposta ve sms gönderebilir">
                                            </v-checkbox>
                                        </v-flex> -->
                      </v-layout>
                    </v-card-title>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-card-title primary-title>
                        <v-flex xs12 sm12 pb-4 pl-2 pt-3 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t("Person-and-Children-Details") }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <!-- <v-btn flat color="primary" @click="CocukEkle()">Çocuk Ekle</v-btn> -->
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          v-for="(item, indPerson) in kisibilgileri"
                          :key="item.id"
                        >
                          <v-layout row wrap>
                            <v-flex xs12 sm1 md2>
                              <v-layout>
                                <v-chip
                                  outline
                                  v-if="item.tip == 0"
                                  class="ma-2"
                                  color="green"
                                  text-color="green"
                                  @click="kisiAra(indPerson)"
                                >
                                  <v-avatar left>
                                    <v-icon color="green">person</v-icon>
                                  </v-avatar>
                                  <span v-if="item.tip == 0">{{
                                    $t("Adult")
                                  }}</span>
                                </v-chip>

                                <v-chip
                                  outline
                                  v-if="item.tip == 1"
                                  class="ma-2"
                                  color="green"
                                  text-color="green"
                                  @click="kisiAra(indPerson)"
                                >
                                  <v-avatar left>
                                    <v-icon color="green">child_care</v-icon>
                                  </v-avatar>
                                  <span v-if="item.tip == 1">
                                    {{ $t("Child") }}
                                  </span>
                                </v-chip>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md3>
                              <v-text-field
                                :label="$t('Name_label')"
                                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                v-model="item.Ad"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md3>
                              <v-text-field
                                :label="$t('Surname_label')"
                                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                v-model="item.Soyad"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md2>
                              <v-text-field
                                :label="$t('Identitynumber_label')"
                                mask="###########"
                                v-model="item.TcKimlikNo"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md2>
                              <tarihcomp
                                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                :etiket="$t('Date-of-Birth')"
                                v-bind:detaygizle="false"
                                v-bind:defaultvalue="'yes'"
                                v-bind:value="item.dogumTarihi"
                                v-model="item.dogumTarihi"
                              >
                              </tarihcomp>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 md12 mt-5>
                                            <v-list>
                                                <v-list-tile>

                                                    <v-flex ml-3 xs12 sm12 md4>
                                                        <v-text-field :label="$t('Identitynumber_label')"
                                                            v-model="rezervasyon.YetiskinSayi" outline></v-text-field>
                                                    </v-flex>
                                                    <v-flex ml-3 xs12 sm12 md4>
                                                        <v-checkbox label="TC Vatandaşı Değilim" outline></v-checkbox>
                                                    </v-flex>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex> -->

                        <!-- <v-flex pl-2 xs12 v-for="item in cocukitems" :key="item" sm12 md12>
                                                <v-layout row wrap>

                                                    <v-flex xs12 sm1 md2>
                                                        <v-layout align-center fill-height row wrap>
                                                            <span
                                                                class="grey--text title font-weight-thin">{{ item+1}}'nci
                                                                Çocuk </span>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm3 md2>
                                                        <v-select label="Yaş Seçimi"
                                                            :items="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]"
                                                            v-model="rezervasyon.OdaDetay.CocukYas[item]"></v-select>

                                                    </v-flex>

                                                </v-layout>
                                            </v-flex> -->
                      </v-card-title>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 pt-2 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 pb-4 pl-4 pt-3 md12>
                        <v-layout row wrap class="project overdue">
                          <v-toolbar flat="" size="120px" dark color="white">
                            <v-toolbar-title>
                              <span
                                class="headline black--text font-weight-bold"
                              >
                                {{ $t("Complex-Special-Request") }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 pl-4 pr-4 sm12 md12>
                        <v-textarea
                          outline
                          v-model="reservation.Message"
                          :label="$t('Your-Request')"
                        >
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex pl-2 xs12 sm3 md3>
              <v-flex xs12 sm12 md12>
                <v-card>
                  <v-img
                    :src="otelInfo.HotelImageList | ilkfoto"
                    height="250px"
                  ></v-img>
                  <v-layout row wrap>
                    <v-card-title primary-title>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <span class="grey--text title">
                            {{ otelInfo.HotelName }}</span
                          >
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <span class="grey--text caption">
                            {{ otelInfo.CityName }} |
                            {{ otelInfo.CountryLongName }}</span
                          >
                        </v-flex>
                        <v-flex pt-1 xs12 sm12 md12>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md6>
                          <v-layout row wrap>
                            <v-flex pa-2 xs12 sm12 md12>
                              <v-layout justify-center>
                                <span class="grey--text title">
                                  {{ $t("Login") }}</span
                                >
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              {{ otelInfo.CheckInTime | dateformat }}
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              {{ otelInfo.CheckInTime | gettime }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex pt-2 pb-2 xs1 sm2 md1>
                          <v-divider vertical></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md5>
                          <v-layout row wrap>
                            <v-flex pa-2 xs12 sm12 md12>
                              <v-layout justify-center>
                                <span class="grey--text title">
                                  {{ $t("Leave") }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="subheading-1">
                                {{ otelInfo.CheckOutTime | dateformat }}</span
                              >
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="subheading-1">
                                {{ otelInfo.CheckOutTime | gettime }}</span
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex pt-1 xs12 sm12 md12>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex pt-1 xs12 sm12 md12>
                          <span class="subtitle-1 black--text">
                            {{ otelInfo.RateName }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1 sm12 md12>
                          <v-layout align-center>
                            <v-icon
                              small
                              v-if="otelInfo.ReturnStatus == 1"
                              color="green"
                              >check
                            </v-icon>
                            &nbsp;<span
                              v-if="otelInfo.ReturnStatus == 1"
                              class="green--text"
                              >{{ $t("Refundable") }}
                            </span>
                            <v-icon
                              small
                              v-if="otelInfo.ReturnStatus == 0"
                              color="red"
                              >cancel
                            </v-icon>
                            &nbsp;<span
                              v-if="otelInfo.ReturnStatus == 0"
                              class="red--text"
                              >iade edilemez</span
                            >
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-1 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs3 sm3 md4>
                              <v-layout row wrap align-center>
                                <v-icon color="grey">person</v-icon>&nbsp;<span
                                  class="grey--text"
                                  >{{ this.reservation.AdultCount }}
                                  {{ $t("Adult") }}</span
                                >
                              </v-layout>
                            </v-flex>

                            <v-flex xs3 sm3 md4>
                              <v-layout row wrap align-center>
                                <v-icon color="grey">child_care</v-icon
                                >&nbsp;<span class="grey--text"
                                  >{{ this.reservation.ChildCount }}
                                  {{ $t("Child") }}</span
                                >
                              </v-layout>
                            </v-flex>

                            <v-flex xs3 sm3 md4>
                              <v-layout row wrap align-center>
                                <v-icon color="grey">brightness_3</v-icon
                                >&nbsp;<span class="grey--text"
                                  >{{
                                    gunfarki(
                                      otelInfo.CheckInTime,
                                      otelInfo.CheckOutTime
                                    )
                                  }}
                                  {{ $t("night") }}</span
                                >
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-flex xs12 sm12 md12>
                        <v-layout
                          row
                          wrap
                          justify-start
                          @click="openMarkupDialog()"
                        >
                          <v-btn color="primary" small>
                            Markup Değiştir
                            <v-icon>currency_lira</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 pt-1 sm12 md12>
                        <v-layout row wrap align-center>
                          <span class="black--text">
                            {{ $t("Price-Details-v2") }}
                          </span>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex
                        xs12
                        sm12
                        md12
                        v-for="(item, index) in odaitems"
                        v-bind:key="index"
                      >
                        <v-layout row wrap>
                          <v-flex xs6 sm6 md6>
                            <div class="caption">
                              {{ $t("Daily-Room-Price") }} ({{
                                item.ReservationDate | dateformat
                              }})
                            </div>
                          </v-flex>
                          <v-flex xs6 sm6 md6 pr-2>
                            <v-layout row wrap justify-end align-center>
                              <div class="caption">
                                {{ item.ArkmanPrice | moneyformat }}
                                {{ item.CurrencyType }}
                              </div>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-layout row wrap>
                          <v-flex xs6 sm6 md6>
                            <div class="caption">Toplam markup</div>
                          </v-flex>
                          <v-flex xs6 sm6 md6 pr-2>
                            <v-layout row wrap justify-end align-center>
                              <div class="caption">
                                {{ otelInfo.MarkupPrice | moneyformat }}
                                &nbsp;{{ otelInfo.CurrencyType }}
                              </div>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-list>
                          <v-list-tile>
                            <div class="title">{{ $t("totalamount") }}</div>
                            <v-spacer></v-spacer>
                            <div class="title red--text">
                              {{ reservation.ArkmanPrice | moneyformat }} 
                              {{ reservation.CurrencyType }}
                            </div>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-btn
                          color="green"
                          v-if="islemTipi != 'hredit' && demoKayit == false"
                          block
                          @click="RezervasyonYap()"
                          ><span class="white--text">
                            BİZİMLE İRTİBAT KURUN
                          </span>
                        </v-btn>
                        <v-btn
                          color="green"
                          v-if="islemTipi != 'hredit' && demoKayit == true"
                          block
                          @click="RezervasyonYap()"
                          ><span class="white--text">
                            {{ $t("Complete-Reservation") }}
                          </span>
                        </v-btn>

                        <v-btn
                          color="green"
                          v-if="islemTipi == 'hredit'"
                          block
                          @click="RezervasyonGuncelle()"
                          ><span class="white--text">
                            {{ $t("Update-Reservation") }}
                          </span>
                        </v-btn>
                      </v-flex>
                    </v-card-title>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="markupDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Markup</v-card-title>
          <v-card-text>
            <v-select
              :label="$t('Markup-Type')"
              :items="markupitems"
              item-text="text"
              item-value="value"
              v-model="markupParams.type"
            ></v-select>
            <v-text-field
              label="Markup"
              v-model="markupParams.price"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="markupDialog = false"
              >İptal</v-btn
            >
            <v-btn color="primary" flat @click="changeMarkup()">Hesapla</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import parainput from "@/components/app/customcomp/parainput.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import kisiadresara from "@/components/app/coper/component/kisiadresara.vue";
import vize from "@/components/app/coper/vize/vize";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  data() {
    return {
      yetkidialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      vizeKisi: vize.Adres(),
      markupDialog: false,
      markupParams: {
        type: 0,
        price: 0,
      },
      markupitems: [
        {
          text: this.$t("Amount"),
          value: 0,
        },
        {
          text: this.$t("Percentage"),
          value: 1,
        },
      ],
      demoKayit: true,
      validmesaj: true,
      mailDialog: {
        AdSoyad: null,
        Email: null,
        SirketAdi: null,
        GSM: null,
        Adres: null,
        Mesaj: null,
      },
      satisControl: false,
      satisDialog: false,
      alternatifInput: {
        BaslangicTarih: null,
        BitisTarih: null,
        MarkupTip: 0,
        MarkupDeger: 0,
      },
      alternatifarama: false,
      alternatifkayitvarmi: false,
      alternatifitems: [],
      islemTipi: null,
      carikod: null,
      statecari: [],
      loadingdialog: false,
      snackbar: false,
      text1: null,
      kisibilgileri: [],
      odaitems: [],
      cocukitems: [],
      validform: true,
      kisitipiitems: [],
      Adres: {
        id: 0,
        kisiTip: 0,
        kisiSira: -1,
        yas: 0,
        profilId: 0,
        tcKimlikNo: "",
        uyeNo: "",
        adSoyad: "",
        adres: "",
        dogumTarihi: null,
        cinsiyet: "",
        telefon1: "",
        gsm: "",
        eMail: "",
      },
      reservation: {
        ArkmanHotelId: 0,
        ReservationType: null,
        ReservationCode: null,
        Name: null,
        SurName: null,
        Mail: null,
        Address: null,
        City: null,
        Country: null,
        Phone: null,
        AdultCount: null,
        ChildCount: null,
        ServicePrice: null,
        CurrencyType: null,
        Message: null,
        StartDate: null,
        EndDate: null,
        Date: null,
        ArkmanPrice: null,
        Passengers: [],
        RoomDetail: {
          RoomId: 0,
          RateId: 0,
          RateName: null,
          AdultCount: 0,
          ChildAge: [],
          StartDate: null,
          EndDate: null,
          ReservationType: null,
        },
        LogInput: {
          UserID: 0,
          CustomerID: 0,
        },
      },
      saticiBilgileri: {},
      rezPrice: 0,
      otelInfo: {
        RoomName: null,
        RoomId: 0,
        HotelImageUrl: null,
        RateId: 0,
        RateName: null,
        ArkmanPrice: 0,
        ServicePrice: 0,
        CurrencyType: null,
        CurrencyValue: 0,
        TotalCount: 0,
        TotalPage: 0.0,
        RoomSize: 0,
        Adt: 0,
        HotelName: null,
        ServiceHotelId: 0,
        ArkmanHotelId: 0,
        CountryShortName: null,
        CountryLongName: null,
        CityName: null,
        Address: null,
        CheckInTime: null,
        CheckOutTime: null,
        ChildAccept: 2,
        Latitude: 0.0,
        Longitude: 0.0,
        Message: null,
        HotelPropertyList: [],
        HotelServiceList: [],
        RoomImageList: [],
        RoomPriceDetaiList: [],
        HotelImageList: [],
        ReturnStatus: 0,
      },
      adresDialogData: {
        dialogShow: false,
        adres: vize.Adres(),
      },
      selectedPersonIndex: 0,
    };
  },
  methods: {
    kisiAra(index) {
      this.adresDialogData.dialogShow = true;
      this.selectedPersonIndex = index;
    },
    openMarkupDialog() {
      this.markupDialog = true;
    },
    changeMarkup() {
      this.loadingdialog = true;
      var params = {
        MarkupPrice: parseInt(this.markupParams.price),
        MarkupType: parseInt(this.markupParams.type),
        ArkmanPrice: this.rezPrice,
        Adt: this.reservation.RoomDetail.Adt,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/CalculateMarkup", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.otelInfo.MarkupPrice = response.body.markupPrice;
            this.reservation.ArkmanPrice = response.body.arkmanPrice;
            this.markupDialog = false;
            this.loadingdialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OtelLoad";
              this.snackbar = true;
              this.loadingdialog = false;
            } else {
              this.text1 = "Service Unavailable-OtelLoad";
              this.snackbar = true;
              this.loadingdialog = false;
            }
          }
        );
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    musaitOdaSec(val) {
      this.odaitems = [];
      //this.reservation.RoomDetail.OdaFiyat = []
      this.reservation.StartDate = val.BaslangicTarih; //Ekleme
      this.reservation.EndDate = val.BitisTarih; //Ekleme
      this.reservation.CurrencyType = val.Kur;
      this.reservation.ArkmanPrice = val.Tutar;
      this.reservation.RoomDetail.StartDate = val.BaslangicTarih; //Ekleme
      this.reservation.RoomDetail.EndDate = val.BitisTarih; //Ekleme

      var HRToplamFiyat = 0; //Ekleme
      var ArkmanToplamFiyat = 0;
      val.TutarList.forEach((element) => {
        // var fiyat = {
        //     Tarih: element.ReservationDate,
        //     Fiyat: element.ArkmanPrice
        // }

        // this.rezervasyon.RoomDetail.OdaFiyat.push(fiyat)

        var yenitutardetay = {
          Fiyat: element.ArkmanPrice,
          HRFiyat: element.ServicePrice,
          Kur: element.CurrencyType,
          KurDeger: 1,
          Tarih: element.ReservationDate,
        };
        this.odaitems.push(yenitutardetay);

        HRToplamFiyat += parseFloat(element.ServicePrice);
        ArkmanToplamFiyat += parseFloat(element.ArkmanPrice);
      });

      this.reservation.ArkmanPrice = ArkmanToplamFiyat; //Ekleme
      this.reservation.ServicePrice = HRToplamFiyat; //Ekleme

      this.alternatifarama = false;
    },
    getmusaitTutar(val) {
      var top = 0;
      var markup = 0;
      val.forEach((element) => {
        markup = element.ArkmanPrice - element.ServicePrice;
        top = top + element.ServicePrice;
      });
      return top + markup;
    },
    getmusaitHRTutar(val) {
      var top = 0;
      val.forEach((element) => {
        top = top + element.ServicePrice;
      });
      return top;
    },
    gunfarki(a, b) {
      var dt1 = new Date(a);
      var dt2 = new Date(b);

      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    },
    musaitOdaGetir() {
      this.loadingdialog = true;
      this.alternatifkayitvarmi = false;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        LogInput: {
          UserID: credentials.UserID,
          CustomerID: credentials.MusteriID,
        },
        ReservationCode: this.reservation.ReservationCode,
        StartDate: this.alternatifInput.BaslangicTarih,
        EndDate: this.alternatifInput.BitisTarih,
        MarkupType: this.alternatifInput.MarkupTip,
        MarkupPrice: this.alternatifInput.MarkupDeger,
        Currency: credentials.ParaBirimi,
      };

      this.$http
        .post(
          auth.HOTELRUNNER_API_URL + "api/v1/AvailabilityReservation",
          params,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          }
        )
        .then(
          (response) => {
            this.loadingdialog = false;
            //var datediff =
            if (response.body.length > 0) {
              var musaititems = {
                BaslangicTarih: this.alternatifInput.BaslangicTarih,
                BitisTarih: this.alternatifInput.BitisTarih,
                Kur: response.body[0].CurrencyType,
                Tutar: this.getmusaitTutar(response.body),
                HrTutar: this.getmusaitHRTutar(response.body),
                OdaTipi: this.reservation.RoomDetail.RateName,
                TutarList: response.body,
              };
              this.alternatifkayitvarmi = true;
              this.alternatifitems = musaititems;
            } else {
              this.text1 = "Uygun kayıt bulunammadı";
              this.snackbar = true;
              this.alternatifkayitvarmi = false;
            }

            //    this.otelInfo = response.body;

            //   this.gunfarki();

            //  this.getSaticiBilgileri(response.body.HROtelID);
          },
          (response) => {
            this.loadingdialog = false;
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AvailabilityReservation";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AvailabilityReservation";
              this.snackbar = true;
            }
          }
        );
    },
    otelbilgiGetir() {
      this.loadingdialog = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var suggestedParam = JSON.parse(window.localStorage.getItem('suggestedParams'));

      var params = {
        LogInput: {
          UserID: credentials.UserID,
          CustomerID: credentials.MusteriID,
        },
        RateId: this.reservation.RoomDetail.RateId,
        StartDate: this.reservation.StartDate,
        EndDate: this.reservation.EndDate,
        Language: "tr",
        MarkupType: 0,
        MarkupPrice: 0,
        Adt: this.reservation.AdultCount,
        CurrencyType: credentials.ParaBirimi,
        ChildAgeList: suggestedParam.ChildAgeList

      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/Select", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.loadingdialog = false;

            this.otelInfo = response.body;
            this.rezPrice = this.reservation.ArkmanPrice;

            if (this.islemTipi == "hredit") {
              this.otelInfo.ArkmanPrice = this.reservation.ArkmanPrice;
              this.otelInfo.ServicePrice = this.reservation.ServicePrice;
            }

            this.gunfarki(
              response.body.CheckInTime,
              response.body.CheckOutTime
            );

            this.getSaticiBilgileri(response.body.ArkmanHotelId);
          },
          (response) => {
            this.loadingdialog = false;
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
            }
          }
        );
    },
    getSaticiBilgileri(val) {
      var params = {
        OtelID: val,
      };
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/OtelLoad", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.saticiBilgileri = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OtelLoad";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OtelLoad";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    KisiEkle() {
      if (this.$refs.formkisiEkle.validate()) {
        if (this.Adres.dogumTarihi != null) {
          var dogumyili = new Date(this.Adres.dogumTarihi);
          this.Adres.yas = helpers.getYear() - dogumyili.getFullYear();
        } else {
          this.Adres.yas = 0;
        }

        var yenikayit = {
          id: null,
          kisiTip: this.Adres.kisiTip,
          kisiSira: -1,
          yas: this.Adres.yas,
          profilId: this.Adres.profilId,
          tcKimlikNo: this.Adres.tcKimlikNo,
          uyeNo: this.Adres.uyeNo,
          adSoyad: this.Adres.adSoyad,
          adres: this.Adres.adres,
          dogumTarihi: this.Adres.dogumTarihi,
          cinsiyet: this.Adres.cinsiyet,
          telefon1: this.Adres.telefon1,
          gsm: this.Adres.gsm,
          eMail: this.Adres.eMail,
        };
      }
    },
    gunfarkialternatif(a, b) {
      var dt1 = new Date(this.alternatifInput.BaslangicTarih);
      var dt2 = new Date(this.alternatifInput.BitisTarih);

      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    },
    getAccountDetails(val) {
      this.loadingdialog = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 2,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.HOTELRUNNERUSERNAME = response.body.UserName;
            auth.HOTELRUNNERUSERPASS = response.body.Password;
            this.demoKayit = response.body.Active;
            if (val != "hredit") {
              this.hredit();
            } else {
              this.hrUpload();
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            }
          }
        );
    },
    hredit() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      this.loadingdialog = true;
      this.text1 = "Bilgileriniz getiriliyor";

      var i, k, top;

      top =
        parseInt(this.$route.query.YetiskinSayi) +
        parseInt(this.reservation.CocukSayi);

      //1 yetişkin 2 çocuk

      for (i = 0; i < this.$route.query.YetiskinSayi; i++) {
        var kayit = {
          id: i,
          tip: 0,
        };
        this.kisitipiitems.push(kayit);
      }

      for (k = i; k < top; k++) {
        var kayit = {
          id: k,
          tip: 1,
        };
        this.kisitipiitems.push(kayit);
      }

      for (i = 0; i < this.reservation.ChildCount; i++) {
        this.cocukitems.push(i);
      }

      this.kisibilgileri = [];

      i = 0;

      this.kisitipiitems.forEach((element) => {
        var yeni = {
          id: i,
          tip: element.tip,
          Ad: null,
          Soyad: null,
          TcKimlikNo: null,
          dogumTarihi: null,
          CoperKisiID: null,
        };
        this.kisibilgileri.push(yeni);
        i++;
      });

      this.reservation.ArkmanHotelId = this.$route.query.ArkmanOtelID;
      this.reservation.ReservationType = "Confirm";
      this.reservation.Address = this.$route.query.Adres;
      this.reservation.City = this.$route.query.Sehir;
      this.reservation.Country = this.$route.query.Ulke;
      this.reservation.AdultCount = parseInt(this.$route.query.YetiskinSayi);
      this.reservation.ArkmanPrice = parseFloat(this.$route.query.ToplamTutar);
      this.reservation.CurrencyType = this.$route.query.Kur;
      this.reservation.StartDate = this.$route.query.BasTarih;
      this.reservation.EndDate = this.$route.query.BitTarih;
      this.reservation.RoomDetail.RoomId = this.$route.query.OdaID;
      this.reservation.RoomDetail.RateId = this.$route.query.RateID;
      //this.reservation.RoomDetail.Kod = null
      this.reservation.RoomDetail.RateName = this.$route.query.SinifAd;
      this.reservation.RoomDetail.Adt = this.$route.query.YetiskinSayi;
      this.reservation.RoomDetail.StartDate = this.$route.query.BasTarih;
      this.reservation.RoomDetail.EndDate = this.$route.query.BitTarih;
      this.reservation.RoomDetail.ArkmanPrice = this.$route.query.ToplamTutar;
      this.reservation.RoomDetail.ReservationType = "Confirm";
      // User ID ve Para Birimi Eklendi
      var suggestedParam = JSON.parse(window.localStorage.getItem('suggestedParams'));

      var params = {
        OtelId: this.$route.query.OtelID,
        RateId: this.$route.query.RateID,
        StartDate: this.$route.query.BasTarih,
        EndDate: this.$route.query.BitTarih,
        Adt: this.$route.query.YetiskinSayi,
        MarkupType: this.$route.query.MarkupTip,
        MarkupPrice: this.$route.query.MarkupDeger,
        CurrencyType: credentials.ParaBirimi,
        ChildAgeList: suggestedParam.ChildAgeList
      };
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomPriceDetailList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.odaitems = response.body;
            //this.reservation.RoomDetail.OdaFiyat = response.body
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RoomPriceDetailList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-RoomPriceDetailList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
        var suggestedParam = JSON.parse(window.localStorage.getItem('suggestedParams'));

      var params = {
        LogInput: {
          UserID: credentials.UserID,
          CustomerID: credentials.MusteriID,
        },
        RateId: this.$route.query.RateID,
        StartDate: this.$route.query.BasTarih,
        EndDate: this.$route.query.BitTarih,
        Language: "tr",
        MarkupType: this.$route.query.MarkupTip,
        MarkupPrice: this.$route.query.MarkupDeger,
        Adt: this.$route.query.YetiskinSayi,
        CurrencyType: credentials.ParaBirimi,
        ChildAgeList: suggestedParam.ChildAgeList
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/Select", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.loadingdialog = false;

            this.otelInfo = response.body;
            this.reservation.ArkmanPrice = response.body.ArkmanPrice;
            this.reservation.ServicePrice = response.body.ServicePrice;
            this.rezPrice = this.reservation.ArkmanPrice;

            this.gunfarki(
              response.body.CheckInTime,
              response.body.CheckOutTime
            );

            this.getSaticiBilgileri(response.body.ArkmanHotelId);
          },
          (response) => {
            this.loadingdialog = false;
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Select";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Select";
              this.snackbar = true;
            }
          }
        );
    },
    hrUpload() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var hrrez = JSON.parse(window.localStorage.getItem("hrrezervasyon"));

      this.loadingdialog = true;
      this.text1 = "Bilgileriniz getiriliyor";

      var params = {
        LogInput: {
          UserID: credentials.UserID,
          CustomerID: credentials.MusteriID,
        },
        ReservationId: this.$route.query.hrid,
        Language: "tr",
        CurrencyType: credentials.ParaBirimi,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/LoadReservation", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.loadingdialog = false;

            this.reservation.ArkmanHotelId = response.body.ArkmanHotelId;
            this.reservation.ReservationType = "Modify";
            this.reservation.Address = response.body.Address;
            this.reservation.City = response.body.City;
            this.reservation.Country = response.body.Country;
            this.reservation.AdultCount = response.body.AdultCount;
            this.reservation.ReservationCode = response.body.ReservationCode;
            this.reservation.Date = response.body.Date;
            this.reservation.ServicePrice = parseFloat(
              response.body.ServicePrice
            );
            this.reservation.ArkmanPrice = parseFloat(
              response.body.ArkmanPrice
            );
            this.reservation.CurrencyType = response.body.CurrencyType;
            this.reservation.StartDate = response.body.StartDate;
            this.reservation.EndDate = response.body.EndDate;
            this.reservation.RoomDetail.RoomId = response.body.RoomId;
            this.reservation.RoomDetail.RateId = response.body.RateId;
            //this.reservation.RoomDetail.Kod = null
            this.reservation.RoomDetail.RateName = response.body.RateName;
            this.reservation.RoomDetail.Adt = response.body.AdultCount;
            this.reservation.RoomDetail.StartDate = response.body.StartDate;
            this.reservation.RoomDetail.EndDate = response.body.EndDate;
            this.reservation.RoomDetail.ServicePrice = parseFloat(
              response.body.ServicePrice
            );
            this.reservation.RoomDetail.Tip = "Modify";
            this.reservation.Message = response.body.Message;
            this.reservation.Mail = response.body.Mail;
            this.odaitems = response.body.RoomPriceDetaiList;
            this.reservation.Phone = response.body.Phone;
            //this.reservation.OdaDetay.OdaFiyat = []

            var priceList = [];
            response.body.RoomPriceDetaiList.forEach((element) => {
              var fiyat = {
                Tarih: element.ReservationDate,
                Fiyat: element.ServicePrice,
              };
              priceList.push(fiyat);
            });

            this.carikod = hrrez.Rezervasyon.cariKod.kod;

            this.otelbilgiGetir();

            var i = 0,
              k = 0,
              top = 0;
            this.kisitipiitems = [];
            this.kisisira = [];

            top =
              parseInt(response.body.YetiskinSayi) +
              parseInt(response.body.CocukSayi);

            //1 yetişkin 2 çocuk

            var adsoyadwithList = [];

            response.body.Passengers.forEach((element) => {
              var coperid = null;

              var sira = hrrez.kalemKisiList
                .map(function (e) {
                  return e.adSoyad;
                })
                .indexOf(element.Name + " " + element.SurName);

              if (sira != -1) {
                coperid = hrrez.kalemKisiList[sira].id;
              } else {
                coperid = null;
              }
              var kayit = {
                id: i,
                tip: element.PaxType,
              };
              this.kisitipiitems.push(kayit);

              var yeni = {
                id: i,
                tip: element.PaxType,
                Ad: element.Name,
                Soyad: element.SurName,
                TcKimlikNo: element.NationalId,
                dogumTarihi: element.BirthDate,
                CoperKisiID: coperid,
              };
              this.kisibilgileri.push(yeni);
              i = i + 1;
            });

            // hrrez.kalemKisiList.forEach(element => {
            //     var sira = adsoyadwithList.map(function (e) {
            //         return e;
            //     }).indexOf(element.adSoyad);

            //     var kayit = {
            //         id: i,
            //         tip: element.Tip
            //     }
            //     this.kisitipiitems.push(kayit)

            //     var yeni = {
            //         id: i,
            //         tip: element.kisiTip,
            //         Ad: element.adSoyad,
            //         Soyad: element.adSoyad,
            //         TcKimlikNo: element.tcKimlikNo,
            //         dogumTarihi: element.dogumTarihi,
            //         CoperKisiID: element.id
            //     }
            //     this.kisibilgileri.push(yeni)
            //     i = i + 1

            // });

            // response.body.Kisiler.forEach(element => {
            //     var kayit = {
            //         id: i,
            //         tip: element.Tip
            //     }
            //     this.kisitipiitems.push(kayit)
            //     i = i + 1
            //     var yeni = {
            //         id: i,
            //         tip: element.Tip,
            //         Ad: element.Ad,
            //         Soyad: element.Soyad,
            //         TcKimlikNo: element.TC,
            //         dogumTarihi: element.DogumTarih,
            //         CoperKisiID:element.CoperKisiID
            //     }
            //     this.kisibilgileri.push(yeni)
            // });

            for (i = 0; i < response.body.ChildCount; i++) {
              this.cocukitems.push(i);
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-LoadReservation";
              this.snackbar = true;
              this.loadingdialog = false;
            } else {
              this.text1 = "Service Unavailable-LoadReservation";
              this.snackbar = true;
              this.loadingdialog = false;
            }
          }
        );
    },
    RezervasyonYap: RezervasyonYap,
    RezervasyonGuncelle,
    CocukEkle: CocukEkle,
  },
  filters: {
    markupgetir: function (val) {
      var markuptop = val.ArkmanPrice - val.ServicePrice;
      return markuptop; //+ ' '+ val.Kur
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
    ilkfoto: function (a) {
      if (a.length > 1) {
        return a[0].Url;
      }
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  },
  components: {
    tarihcomp,
    snackbarcomp,
    hotelloadingcomp,
    caricomp,
    yuzdeinput,
    parainput,
    tanitimMail,
    yetkidialog,
    kisiadresara,
  },
  watch: {
    "adresDialogData.adres": function () {
      this.reservation.Phone = this.adresDialogData.adres.gsm;
      this.reservation.Mail = this.adresDialogData.adres.eMail;
      this.reservation.Address = this.adresDialogData.adres.adres;

      if (
        this.adresDialogData.adres.lastName == null ||
        this.adresDialogData.adres.lastName == ""
      ) {
        var nameAndSurName = this.adresDialogData.adres.firstName.split(" ");

        this.kisibilgileri[this.selectedPersonIndex].Ad = nameAndSurName[0];

        if (nameAndSurName.length == 3) {
          this.kisibilgileri[this.selectedPersonIndex].Soyad =
            nameAndSurName[1] + " " + nameAndSurName[4];
        } else {
          this.kisibilgileri[this.selectedPersonIndex].Soyad =
            nameAndSurName[1];
        }
      } else {
        this.kisibilgileri[this.selectedPersonIndex].Ad =
          this.adresDialogData.adres.firstName;
        this.kisibilgileri[this.selectedPersonIndex].Soyad =
          this.adresDialogData.adres.lastName;
      }
      this.kisibilgileri[this.selectedPersonIndex].TcKimlikNo =
        this.adresDialogData.adres.tcKimlikNo;
      this.kisibilgileri[this.selectedPersonIndex].dogumTarihi =
        this.adresDialogData.adres.dogumTarihi;
    },
    alternatifarama: function (val) {
      if (val) {
        this.alternatifInput.BaslangicTarih = this.reservation.StartDate;
        this.alternatifInput.BitisTarih = this.reservation.EndDate;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.reservation.ChildCount = 0;
  //this.reservation.RoomDetail.ChildCount = 0

  if (
    this.$route.query.islemTip != undefined &&
    this.$route.query.islemTip != null
  ) {
    if (this.$route.query.islemTip == "hrget") {
      this.islemTipi = "hrget";
    } else if (this.$route.query.islemTip == "hredit") {
      this.islemTipi = "hredit";
    } else {
      this.islemTipi = "hryeni";
    }
  } else {
    this.islemTipi = "hryeni";
  }
  this.getAccountDetails(this.islemTipi);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};

function CocukEkle() {
  var yas = this.cocukyas1;

  var birthYear = yas.substring(0, 4);
  var birthMonth = yas.substring(5, 7);
  var birthDay = yas.substring(8, 10);
  var todayDate = new Date();
  var todayYear = todayDate.getFullYear();
  var todayMonth = todayDate.getMonth();
  var todayDay = todayDate.getDate();
  var age = todayYear - birthYear;

  if (todayMonth < birthMonth - 1) {
    age--;
  }

  if (birthMonth - 1 == todayMonth && todayDay < birthDay) {
    age--;
  }
  this.cocukitems.push(age);
}



function RezervasyonYap() {
  //Kullanıcının HotelRunner ile Anlaşması varmı ?

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  var rezervasyon = {};
  this.reservation.Passengers = [];
  this.reservation.RoomDetail.ChildAge = [];
  this.kisibilgileri.forEach((element) => {
    var tip = 0;
    if (element.Tip == 1) {
      tip = 1;
    } else {
      tip = 0;
    }

    var yenikisi = {
      Name: element.Ad,
      SurName: element.Soyad,
      NationalId: element.TcKimlikNo,
      PaxType: tip, // 0 Yetişkin   , 1 Çocuk
      BirthDate: element.dogumTarihi,
      ReservationCode: this.reservation.ReservationCode,
      CoperPassID: element.CoperKisiID,
    };

    this.reservation.Passengers.push(yenikisi);

    var yas = 0;
    if (element.dogumTarihi != null) {
      var dogumyili = new Date(element.dogumTarihi);
      yas = helpers.getYear() - dogumyili.getFullYear();
    } else {
      yas = 0;
    }

    if (element.tip == 1) {
      this.reservation.RoomDetail.ChildAge.push(yas);
    }
  });

  this.reservation.Name = this.kisibilgileri[0].Ad;
  this.reservation.SurName = this.kisibilgileri[0].Soyad;
  this.reservation.LogInput.CustomerID = credentials.MusteriID;
  this.reservation.LogInput.UserID = credentials.UserID;
  this.reservation.RoomDetail.AdultCount = parseInt(
    this.reservation.RoomDetail.Adt
  );
  if (this.reservation.RoomDetail.ChildCount == null) {
    this.reservation.RoomDetail.ChildCount = 0;
  } else {
    this.reservation.RoomDetail.ChildCount = parseInt(
      this.reservation.RoomDetail.ChildCount
    );
  }

  var o = 1;
  //  if (o == 0) {
  if (this.$refs.formrezervasyon.validate()) {
    if (this.demoKayit != true) {
      this.$refs.tanitimdialog.open(1);
    } else {
      this.loadingdialog = true;
      this.text1 = "Rezervasyonunuz yapılıyor,";

      var params = this.reservation;
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/MakeReservation", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.Status == true) {
              this.text1 =
                "Hotel Runner rezervasyon işleminiz tamamlandı, Coper kayıt işlemleri için yönlendiriliyorsunuz,";

              if (this.islemTipi == "hrget" || this.islemTipi == "hredit") {
                var rez = JSON.parse(
                  window.localStorage.getItem("hrrezervasyon")
                );

                window.localStorage.removeItem("hrrezervasyon");

                rezervasyon = {
                  Rezervasyon: rez.Rezervasyon,
                  HotelRuner: this.reservation,
                  AdresBilgileri: this.kisibilgileri,
                  OtelBilgi: this.otelInfo,
                  hrislem: true,
                  hrislemTipi: this.islemTipi,
                  CariKodu: this.carikod,
                  SaticiBilgileri: this.saticiBilgileri,
                  RezervasyonID: response.body.RezID,
                  kalemIndex: rez.kalemIndex,
                  kalemKisiList: rez.kalemKisiList,
                };

                window.localStorage.setItem(
                  "hrrezervasyon",
                  JSON.stringify(rezervasyon)
                );

                setTimeout(
                  function () {
                    var link = null;
                    if (this.islemTipi == "hrget") {
                      link = "#/coper/rezervasyon/index/id?islem=hrget";
                    } else {
                      link = "#/coper/rezervasyon/index/id?islem=hredit";
                    }
                    window.open(link, "_self");
                  }.bind(this),
                  5000
                );
              } else {
                rezervasyon = {
                  Rezervasyon: null,
                  HotelRuner: this.reservation,
                  AdresBilgileri: this.kisibilgileri,
                  OtelBilgi: this.otelInfo,
                  hrislem: true,
                  hrislemTipi: this.islemTipi,
                  CariKodu: this.carikod,
                  SaticiBilgileri: this.saticiBilgileri,
                  RezervasyonID: response.body.RezID,
                };

                window.localStorage.setItem(
                  "hrrezervasyon",
                  JSON.stringify(rezervasyon)
                );

                setTimeout(
                  function () {
                    var link = "#/coper/rezervasyon/index/id?islem=hryeni";
                    window.open(link, "_target");
                  }.bind(this),
                  5000
                );
              }
            } else {
              (this.loadingdialog = false),
                (this.text1 = response.body.ResponseMessage);
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              (this.loadingdialog = false),
                (this.text1 = "Service Unavailable-MakeReservation");
              this.snackbar = true;
              this.progress = false;
            } else {
              (this.loadingdialog = false),
                (this.text1 = "Service Unavailable-MakeReservation");
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    }
  } else {
    this.text1 = "Lütfen gerekli alanları doldurun";
    this.snackbar = true;
  }
}

function RezervasyonGuncelle() {
  var rezervasyon = {};
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  this.reservation.Passengers = [];
  this.reservation.RoomDetail.ChildAge = [];

  this.kisibilgileri.forEach((element) => {
    var tip = 0;
    if (element.Tip == 1) {
      tip = 1;
    } else {
      tip = 0;
    }

    var yenikisi = {
      Name: element.Ad,
      SurName: element.Soyad,
      NationalId: element.TcKimlikNo,
      PaxType: tip, // 0 Yetişkin   , 1 Çocuk
      BirthDate: element.dogumTarihi,
      ReservationCode: this.reservation.ReservationCode,
      CoperPassID: element.CoperKisiID,
    };

    this.reservation.Passengers.push(yenikisi);

    var yas = 0;
    if (element.dogumTarihi != null) {
      var dogumyili = new Date(element.dogumTarihi);
      yas = helpers.getYear() - dogumyili.getFullYear();
    } else {
      yas = 0;
    }

    if (element.tip == 1) {
      this.rezervasyon.RoomDetail.ChildAge.push(yas);
    }
  });

  this.reservation.Name = this.kisibilgileri[0].Ad;
  this.reservation.SurName = this.kisibilgileri[0].Soyad;
  this.reservation.LogInput.CustomerID = credentials.MusteriID;
  this.reservation.LogInput.UserID = credentials.UserID;

  var o = 1;
  //  if (o == 0) {
  if (this.$refs.formrezervasyon.validate()) {
    this.loadingdialog = true;
    this.text1 = "Rezervasyonunuz yapılıyor,";
    this.reservation.RoomDetail.AdultCount = parseInt(
      this.reservation.RoomDetail.Adt
    );
    if (this.reservation.RoomDetail.ChildCount == null) {
      this.reservation.RoomDetail.ChildCount = 0;
    } else {
      this.reservation.RoomDetail.ChildCount = parseInt(
        this.reservation.RoomDetail.ChildCount
      );
    }

    var params = this.reservation;

    this.$http
      .post(auth.HOTELRUNNER_API_URL + "api/v1/UpdateReservation", params, {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(
              auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
            ),
        },
      })
      .then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 =
              "Hotel Runner rezervasyon işleminiz tamamlandı, Coper kayıt işlemleri için yönlendiriliyorsunuz,";

            if (this.islemTipi == "hrget" || this.islemTipi == "hredit") {
              var rez = JSON.parse(
                window.localStorage.getItem("hrrezervasyon")
              );

              window.localStorage.removeItem("hrrezervasyon");

              rezervasyon = {
                Rezervasyon: rez.Rezervasyon,
                HotelRuner: this.reservation,
                AdresBilgileri: this.kisibilgileri,
                OtelBilgi: this.otelInfo,
                hrislem: true,
                hrislemTipi: this.islemTipi,
                CariKodu: this.carikod,
                SaticiBilgileri: this.saticiBilgileri,
                RezervasyonID: response.body.RezID,
                kalemIndex: rez.kalemIndex,
                kalemKisiList: rez.kalemKisiList,
              };

              window.localStorage.setItem(
                "hrrezervasyon",
                JSON.stringify(rezervasyon)
              );

              setTimeout(
                function () {
                  var link = null;
                  if (this.islemTipi == "hrget") {
                    link = "#/coper/rezervasyon/index/id?islem=hrget";
                  } else {
                    link = "#/coper/rezervasyon/index/id?islem=hredit";
                  }
                  window.open(link, "_self");
                }.bind(this),
                5000
              );
            } else {
              rezervasyon = {
                Rezervasyon: null,
                HotelRuner: this.reservation,
                AdresBilgileri: this.kisibilgileri,
                OtelBilgi: this.otelInfo,
                hrislem: true,
                hrislemTipi: this.islemTipi,
                CariKodu: this.carikod,
                SaticiBilgileri: this.saticiBilgileri,
                RezervasyonID: response.body.RezID,
              };

              window.localStorage.setItem(
                "hrrezervasyon",
                JSON.stringify(rezervasyon)
              );

              setTimeout(
                function () {
                  var link = "#/coper/rezervasyon/index/id?islem=hryeni";
                  window.open(link, "_target");
                }.bind(this),
                5000
              );
            }
          } else {
            (this.loadingdialog = false),
              (this.text1 = response.body.ResponseMessage);
            this.snackbar = true;
          }
        },
        (response) => {
          if (response.status === 0) {
            (this.loadingdialog = false),
              (this.text1 = "Service Unavailable-UpdateReservation");
            this.snackbar = true;
            this.progress = false;
          } else {
            (this.loadingdialog = false),
              (this.text1 = "Service Unavailable-UpdateReservation");
            this.snackbar = true;
            this.progress = false;
          }
        }
      );
  } else {
    this.text1 = "Lütfen gerekli alanları doldurun";
    this.snackbar = true;
  }
}
</script>
